/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-nested-ternary */
import { ToastContainer } from 'react-toastify'
import { BelowInput } from '../../components/BelowInput/BelowInput'
import { Input } from '../../components/Input/Input'
// import LoginImg2 from '../../assets/images/LoginImg2.png'
import { LogoCartivia } from '../../components/LogoCartivia'

import { Title } from '../../components/TitleLogin/Title.style'
import 'react-toastify/dist/ReactToastify.css'
import { useAlteraSenha } from './useAlteraSenha'
import {
  Container,
  Info,
  NovaSenha,
  RealizeSeuLogin,
  Wrapper,
} from './alteraSenha.style'

export function AlteraSenha() {
  const {
    setSenha,
    senha,
    confirmarSenha,
    setConfirmarSenha,
    handleRedefinirSenha,
    handleKeyDown,
    campoObrigatorioNovaSenha,
    campoObrigatorioConfirmarSenha,
    senhaNaoCoincide,
    senhaInvalida,
  } = useAlteraSenha()

  return (
    <Container>
      <ToastContainer position="top-left" theme="dark" />
      <RealizeSeuLogin>
        <Wrapper>
          <LogoCartivia vertical comTagline tamanho={32} />
          <Title titleType="SUB-TITLE">Redefina a sua senha</Title>
          <NovaSenha>
            <Input
              changeIsPassword
              labelText="Nova senha"
              value={senha}
              onChange={event => setSenha(event.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Insira nova senha"
            />
            {campoObrigatorioNovaSenha ? (
              <span>*O campo nova senha é obrigatório</span>
            ) : (
              ''
            )}
            <Input
              changeIsPassword
              labelText="Confirmar senha"
              value={confirmarSenha}
              onChange={event => setConfirmarSenha(event.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Repita a nova senha"
            />
            {campoObrigatorioConfirmarSenha ? (
              <span>*O campo confirmar senha é obrigatório</span>
            ) : (
              ''
            )}
            {senhaNaoCoincide ? (
              <span>*As senhas não coincidem. Tente novamente.</span>
            ) : (
              ''
            )}
            {senhaInvalida && (
              <Info>
                A senha deve conter no mínimo 8 caracteres com pelo menos um
                número, uma letra maiúscula e uma letra minúscula.
              </Info>
            )}
          </NovaSenha>
          <BelowInput
            isLembrarMe={false}
            buttonText="Redefinir senha"
            onclick={handleRedefinirSenha}
          />
        </Wrapper>
      </RealizeSeuLogin>
    </Container>
  )
}
